import './App.css';
import Welcome from './pages/Welcome.tsx';

function App() {
  return (<div style={{minWidth:400, margin:0}}>
    <Welcome />
  </div>);
}

export default App;
